export interface Comment {
  id: number;
  articleId: number;
  username: string;
  avatar: string;
  content: string;
  rating: number;
  date: string;
  likes: number;
}

export const comments: Comment[] = [
  {
    id: 1,
    articleId: 1,
    username: '吃瓜群众001',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20avatar%20icon%20style%20portrait%2C%20simple%20geometric%20face%2C%20warm%20neutral%20background&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '真的假的？我之前还挺喜欢小甜甜的，没想到啊...这人设塌得太彻底了。',
    rating: 5,
    date: '2026-07-02',
    likes: 234,
  },
  {
    id: 2,
    articleId: 1,
    username: '爆料爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20avatar%20style%20portrait%2C%20simple%20shapes%2C%20warm%20amber%20tones%20background&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '网红圈的水太深了，表面清纯背后不知道有多乱。支持博主继续爆料！',
    rating: 5,
    date: '2026-07-02',
    likes: 189,
  },
  {
    id: 3,
    articleId: 1,
    username: '理性吃瓜',
    avatar: 'https://readdy.ai/api/search-image?query=Minimal%20avatar%20icon%2C%20clean%20geometric%20design%2C%20neutral%20warm%20background%20color&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '等一个官方回应吧，现在这些爆料真真假假的，不好判断。',
    rating: 3,
    date: '2026-07-01',
    likes: 145,
  },
  {
    id: 4,
    articleId: 3,
    username: '娱乐圈老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20avatar%20illustration%2C%20flat%20design%20style%2C%20warm%20tones%20background&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: '早就猜到了！男星和经纪人这个组合太经典了，圈里这种关系不要太多。',
    rating: 5,
    date: '2026-07-02',
    likes: 567,
  },
  {
    id: 5,
    articleId: 3,
    username: '追星十年',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20avatar%20portrait%2C%20soft%20colors%2C%20warm%20background&width=100&height=100&seq=avatar-05&orientation=squarish',
    content: '心碎了一地，粉了五年的偶像啊...虽然很伤心但还是要感谢51黑料网让我看清真相。',
    rating: 4,
    date: '2026-07-02',
    likes: 432,
  },
  {
    id: 6,
    articleId: 4,
    username: '码农看世界',
    avatar: 'https://readdy.ai/api/search-image?query=Geometric%20avatar%20design%2C%20tech%20style%2C%20warm%20neutral%20background&width=100&height=100&seq=avatar-06&orientation=squarish',
    content: '作为技术人员，我对这种操纵算法的行为深恶痛绝。支持严惩！',
    rating: 5,
    date: '2026-07-01',
    likes: 678,
  },
  {
    id: 7,
    articleId: 5,
    username: '人间清醒',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20flat%20avatar%20icon%2C%20clean%20minimal%20design%2C%20warm%20tones&width=100&height=100&seq=avatar-07&orientation=squarish',
    content: '现在的网红有几个是真的？都是包装出来的，看看乐子就行了别当真。',
    rating: 4,
    date: '2026-07-01',
    likes: 345,
  },
  {
    id: 8,
    articleId: 7,
    username: '哈哈怪',
    avatar: 'https://readdy.ai/api/search-image?query=Cheerful%20abstract%20avatar%20design%2C%20bright%20warm%20colors%2C%20minimal%20style&width=100&height=100&seq=avatar-08&orientation=squarish',
    content: '直播事故那个合集笑死我了，特别是粉底液打翻那个，尴尬得我脚趾抠地！',
    rating: 5,
    date: '2026-07-02',
    likes: 890,
  },
  {
    id: 9,
    articleId: 10,
    username: '受害者联盟',
    avatar: 'https://readdy.ai/api/search-image?query=Serious%20minimal%20avatar%20icon%2C%20dark%20warm%20background%2C%20simple%20geometric&width=100&height=100&seq=avatar-09&orientation=squarish',
    content: '我也遇到过类似的情况！给某个主播打赏了不少钱，后来发现她同时在跟好几个"大哥"暧昧。大家一定要擦亮眼睛！',
    rating: 5,
    date: '2026-06-27',
    likes: 234,
  },
  {
    id: 10,
    articleId: 12,
    username: '女团饭',
    avatar: 'https://readdy.ai/api/search-image?query=Colorful%20minimal%20avatar%20design%2C%20pop%20style%2C%20warm%20background&width=100&height=100&seq=avatar-10&orientation=squarish',
    content: '虽然是独家猛料但我还是要说，艺人也是人，谈恋爱怎么了？公司的恋爱禁令本来就很不合理。',
    rating: 3,
    date: '2026-06-25',
    likes: 567,
  },
  {
    id: 11,
    articleId: 14,
    username: '正义使者',
    avatar: 'https://readdy.ai/api/search-image?query=Bold%20minimal%20avatar%20icon%2C%20strong%20geometric%20shapes%2C%20warm%20tones&width=100&height=100&seq=avatar-11&orientation=squarish',
    content: '家暴零容忍！这种人必须受到法律制裁，不管他是什么身份！',
    rating: 5,
    date: '2026-06-23',
    likes: 1234,
  },
  {
    id: 12,
    articleId: 16,
    username: '营销观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20minimal%20avatar%20design%2C%20business%20style%2C%20warm%20neutral%20background&width=100&height=100&seq=avatar-12&orientation=squarish',
    content: '这篇分析太到位了！现在的网红卖惨已经形成了完整的产业链，从策划到变现一条龙。',
    rating: 5,
    date: '2026-06-21',
    likes: 456,
  },
];